import {BrukerId, GruppeMedlemListeModell, KommentarModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {Temporal} from "temporal-polyfill";
import {lesZonedDateTimeSerialisert, månederIPlainDatePeriode} from "felles-ng2/støttefunksjoner/temporal";
import {PlainDatePeriode} from "felles-ng2/støttefunksjoner/plainDatePerioder";
import {ZonedDateTimePeriode} from "felles-ng2/støttefunksjoner/zonedDateTimePerioder";
import PlainDate = Temporal.PlainDate;
import ZonedDateTime = Temporal.ZonedDateTime;

export function lesKommentarPublisertDato(kommentar: KommentarModell): ZonedDateTime {
    return lesZonedDateTimeSerialisert(kommentar.publisertDato);
}

export function lesKommentarSenestePubliseringsdato(kommentar: KommentarModell): ZonedDateTime {
    return lesZonedDateTimeSerialisert(kommentar.senestePubliseringsdato);
}

export function varsledeEksTrådForfatter(kommentar: KommentarModell): GruppeMedlemListeModell[] {
    return kommentar.varslede
      .filter(medlem => medlem.id !== kommentar.publisertAv.id);
}

/** Sortere på publisertDato, eldste først */
export function sorterKommentarPåDato(a: KommentarModell, b: KommentarModell): number {
    if (a === b) return 0;
    return lesKommentarPublisertDato(a).epochMilliseconds - lesKommentarPublisertDato(b).epochMilliseconds
}

/** Returnerer antall kommentarer og svar i angitt samling */
export function antallKommentarerOgSvar(kommentarer: KommentarModell[]): number {
    return kommentarer
      .map(kommentar => kommentar.svar.length + 1)
      .reduce((a, b) => a + b, 0);
}

/** Sann dersom kommentar eller tilknyttet svar har blitt publisert i angitt periode */
export function kommentarerPublisertIPeriode(kommentar: KommentarModell, periode: ZonedDateTimePeriode): boolean {
    return lesKommentarSenestePubliseringsdato(kommentar).epochMilliseconds >= periode.start.epochMilliseconds
      && lesKommentarSenestePubliseringsdato(kommentar).epochMilliseconds <= periode.slutt.epochMilliseconds;
}

/** Sann dersom kommentar eller noe tilknyttet svar har blitt publisert av angitt bruker */
export function kommentarerPublisertAv(kommentar: KommentarModell, brukerId: BrukerId): boolean {
    return kommentar.publisertAv.brukerId == brukerId
      || kommentar.svar.some(svar => svar.publisertAv.brukerId == brukerId);
}

/** Sann dersom kommentar og ALLE tilknyttet svar har blitt publisert av angitt bruker */
export function kommentarerKunPublisertAv(kommentar: KommentarModell, brukerId: BrukerId): boolean {
    return kommentar.publisertAv.brukerId == brukerId
      && kommentar.svar.every(svar => svar.publisertAv.brukerId == brukerId);
}

/** Sann dersom hverken kommentar eller noe tilknyttet svar har blitt publisert av angitt bruker */
export function kommentarerIkkePublisertAv(kommentar: KommentarModell, brukerId: BrukerId): boolean {
    return kommentar.publisertAv.brukerId != brukerId
      && !kommentar.svar.some(svar => svar.publisertAv.brukerId == brukerId);
}

/** Returnerer liste med kommentarer gruppert månedsvis basert på siste svars dato.
 * Merk at vi forventer at alle angitte kommentarer er innfor angitt periode */
export function kommentarerGruppertMånedsvis(kommentarer: KommentarModell[], periode: PlainDatePeriode): Kommentargruppe[] {
    return månederIPlainDatePeriode(periode)
      .reverse()
      .map(dato => {
          const kommentarerIPerioden = kommentarer
            .filter(kommentar => lesKommentarSenestePubliseringsdato(kommentar).year == dato.year && lesKommentarSenestePubliseringsdato(kommentar).month == dato.month)
            //sorter i fallende rekkefølge, nyeste først
            .sort((a, b) => lesKommentarSenestePubliseringsdato(b).epochMilliseconds - lesKommentarSenestePubliseringsdato(a).epochMilliseconds);
          return {dato: dato, traader: kommentarerIPerioden};
      });
}

export interface Kommentargruppe {
    dato: PlainDate;
    traader: KommentarModell[];
}
